/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import colorLabels from 'cio/utils/color-labels';
import { DashboardTestSplitAction } from 'cio/utils/metrics/models/dashboard-tests';
import { SortDirection } from 'cio/utils/sort';

interface DashboardPageTestsCardCampaignsArgs {
  splitActions: DashboardTestSplitAction[];
  sortByItem: {
    label: string;
    value: 'opened' | 'clicked' | 'converted' | 'most_recent' | 'longest_running';
    sortBy: string;
    sortDirection: SortDirection;
  };
  isLoading: boolean;
  trackNavigate: (destination: string) => unknown;
}

const VALID_MEASURES = ['opened', 'clicked', 'converted'];

export default class DashboardPageTestsCampaignsCard extends Component<DashboardPageTestsCardCampaignsArgs> {
  COLOR_LABELS = colorLabels;

  get ctboMeasureName() {
    // If we're sorting by 'most recent' or 'longest running', default to
    // 'opened' meeasure for calculating CTBO
    if (!VALID_MEASURES.includes(this.args.sortByItem.value)) {
      return 'opened';
    }

    return this.args.sortByItem.value;
  }

  get sortedSplitActions() {
    let ctboMeasureKey = `${this.ctboMeasureName}CTBO`;
    let { sortDirection } = this.args.sortByItem;
    let shouldSortByMeasure = VALID_MEASURES.includes(this.args.sortByItem.value);

    return [...this.args.splitActions].sort((a, b) => {
      if (shouldSortByMeasure && ['opened', 'clicked', 'converted'].includes(this.ctboMeasureName)) {
        let [, variationA] = a.splitMetrics;
        let [, variationB] = b.splitMetrics;

        let variationACTBOValue = (variationA as any)[ctboMeasureKey];
        let variationBCTBOValue = (variationB as any)[ctboMeasureKey];

        // We want to sort tests without enough data to calculate CTBO above tests
        // that have a CTBO of 0
        if (!variationA.hasEnoughDataForCTBO && variationB.hasEnoughDataForCTBO && variationBCTBOValue === 0) {
          return 1;
        }
        if (!variationB.hasEnoughDataForCTBO && variationA.hasEnoughDataForCTBO && variationACTBOValue === 0) {
          return -1;
        }
        if (!variationA.hasEnoughDataForCTBO && !variationB.hasEnoughDataForCTBO) {
          // If both items don't have enough data, sort those by name
          return a.name.localeCompare(b.name);
        }

        if (variationACTBOValue > variationBCTBOValue) {
          return -1;
        }

        if (variationACTBOValue < variationBCTBOValue) {
          return 1;
        }

        return 0;
      } else {
        // If we're not sorting by a CTBO score, we're sorting by a timestamp
        let aSortValue = (a as any)[this.args.sortByItem.sortBy];
        let bSortValue = (b as any)[this.args.sortByItem.sortBy];

        let sortValue = 0;

        if (aSortValue > bSortValue) {
          sortValue = 1;
        }

        if (aSortValue < bSortValue) {
          sortValue = -1;
        }

        if (sortDirection === SortDirection.Descending) {
          sortValue = sortValue * -1;
        }

        return sortValue;
      }
    });
  }
}
